import React from "react";
import { Helmet } from "react-helmet";
import { Box, BoxProps } from "@mui/material";

interface IPageProps extends BoxProps {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const PageShell = (props: IPageProps) => {
  const { title, subtitle, children, sx, className, ...rest } = props;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Box
        className={['app-page', className].filter(Boolean).join(' ')}
        sx={{
          display: "grid",
          gap: 0,
          minHeight: 0,
          minWidth: 0,
          width: "100%",
          maxWidth: "100%",
          overflow: "visible",
          ...sx,
        }}
        {...rest}
      >
        <Box className="app-page__body">{children}</Box>
      </Box>
    </>
  );
};

export default PageShell;
